import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../CSS/FooterMarquee.css';

function FooterMarquee() {
  const marqueeRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  const text = t('Footer.marqueeText') + '     ';

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (marqueeRef.current) {
      observer.observe(marqueeRef.current);
    }

    return () => {
      if (marqueeRef.current) {
        observer.unobserve(marqueeRef.current);
      }
    };
  }, []);

  return (
    <div
      ref={marqueeRef}
      className={`footer-marquee ${isVisible ? 'visible' : ''}`}
    >
      <div className="marquee-track">
        <span>{text.repeat(10)}</span>
        <span>{text.repeat(10)}</span>
      </div>
    </div>
  );
}

export default FooterMarquee;
